import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import './Presentation.scss';

const Presentation = () => {
  return (
    <div className="presentation-page">
      <PageHeader 
        title="Présentation" 
        subtitle="Talents africains, standards mondiaux"
        breadcrumb={['Accueil', 'Présentation']}
        image="/assets/IMG/Header_Presentation.jpg"
        hideText={true}
      />

      <div className="presentation-container">
        <section className="intro-section">
          <div className="intro-content">
            <p className="lead-text">
              Après plus de 8 ans à travailler dans l'orientation et la performance des élèves et étudiants en Afrique, 
              la vision de créer une nouvelle race d'étudiant africains se solidifie en 2026. BE TALENTED est une fondation 
              dédiée au développement du capital humain africain, avec pour ambition de former, orienter et élever une 
              génération d'étudiants et de jeunes talents hautement performants, autonomes et stratégiquement préparés 
              aux défis du continent africain.
            </p>
          </div>
        </section>

        <section className="context-section">
          <h2>Contexte & Justification</h2>
          <p>
            Le continent africain dispose d'un potentiel humain exceptionnel. Toutefois, les défis contemporains liés à 
            la compétitivité, à l'employabilité, au leadership et à la performance exigent une approche nouvelle du 
            développement des talents.
          </p>
          <p>
            BE TALENTED s'inscrit dans cette dynamique en proposant une plateforme d'élévation intellectuelle, 
            comportementale et stratégique.
          </p>
        </section>

        <section className="mission-vision-section">
          <div className="mv-grid">
            <div className="mv-card mission-card">
              <div className="mv-icon">
                <svg viewBox="0 0 50 50" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M25 5 L30 15 L42 17 L33 26 L35 38 L25 33 L15 38 L17 26 L8 17 L20 15 Z"/>
                  <circle cx="25" cy="25" r="3" fill="currentColor"/>
                </svg>
              </div>
              <h3>Notre Mission</h3>
              <p>
                La Fondation BE TALENTED a pour mission de former, orienter et accompagner les étudiants africains 
                en développant leur excellence intellectuelle, leur leadership, leurs compétences stratégiques et leur 
                solidité mentale, afin de favoriser leur performance durable et leur contribution active au développement 
                du continent africain.
              </p>
            </div>

            <div className="mv-card vision-card">
              <div className="mv-icon">
                <svg viewBox="0 0 50 50" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M25 8 L15 20 L15 40 L35 40 L35 20 Z"/>
                  <circle cx="25" cy="12" r="4" fill="currentColor"/>
                  <path d="M20 26 L30 26"/>
                  <path d="M20 32 L30 32"/>
                  <rect x="22" y="35" width="6" height="5"/>
                </svg>
              </div>
              <h3>Notre Vision</h3>
              <p>
                Contribuer à l'émergence d'une génération africaine d'élite, hautement compétente, mentalement solide 
                et stratégiquement préparée, capable d'impacter durablement le développement économique, social et 
                institutionnel du continent.
              </p>
            </div>
          </div>
        </section>

        <section className="values-section">
          <h2>Nos Valeurs Fondatrices</h2>
          <div className="values-grid">
            <div className="value-card" style={{ '--card-accent': '#E8731A', '--card-bg': 'rgba(232,115,26,0.22)', '--card-bg-hover': 'rgba(232,115,26,0.38)' }}>
              <h3>Excellence</h3>
              <p>Nous cultivons la rigueur, la performance et les standards élevés.</p>
            </div>
            <div className="value-card" style={{ '--card-accent': '#3B5BA5', '--card-bg': 'rgba(59,91,165,0.22)', '--card-bg-hover': 'rgba(59,91,165,0.38)' }}>
              <h3>Responsabilité</h3>
              <p>Nous promouvons l’autonomie, la discipline et l’engagement individuel.</p>
            </div>
            <div className="value-card" style={{ '--card-accent': '#D63070', '--card-bg': 'rgba(214,48,112,0.22)', '--card-bg-hover': 'rgba(214,48,112,0.38)' }}>
              <h3>Leadership</h3>
              <p>Nous développons des talents capables d’influencer positivement leur environnement.</p>
            </div>
            <div className="value-card" style={{ '--card-accent': '#2D6A4F', '--card-bg': 'rgba(45,106,79,0.22)', '--card-bg-hover': 'rgba(45,106,79,0.38)' }}>
              <h3>Intégrité</h3>
              <p>Nous valorisons l’éthique, la crédibilité et la cohérence.</p>
            </div>
            <div className="value-card" style={{ '--card-accent': '#7B2FBE', '--card-bg': 'rgba(123,47,190,0.22)', '--card-bg-hover': 'rgba(123,47,190,0.38)' }}>
              <h3>Élévation</h3>
              <p>Nous plaçons la transformation mentale et stratégique au cœur du développement.</p>
            </div>
          </div>
        </section>

        <section className="axes-section">
          <h2>Nos Axes Stratégiques</h2>
          
          <div className="axe-item">
            <div className="axe-number">1</div>
            <div className="axe-content">
              <h3>Formation & Développement des capacités (CODE)</h3>
              <p>
                CODE est un programme intensif de transformation du mindset destiné aux jeunes leaders, étudiants 
                ambitieux à fort potentiel. L'objectif est de former des individus mentalement solides, disciplinés et 
                orientés performance durable. Cette formation se fait chaque deux mois afin de renforcer les capacités 
                et compétences des étudiants Africains.
              </p>
              <div className="modules-list">
                <strong>Nos Modules :</strong>
                <ul>
                  <li>Leadership & soft skills / Excellence académique</li>
                  <li>Performance personnelle / Discipline mentale</li>
                  <li>Résilience & confiance stratégique / Culture de performance</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="axe-item">
            <div className="axe-number">2</div>
            <div className="axe-content">
              <h3>Orientation & Compétence (TRAJECTOIRE)</h3>
              <p>
                TRAJECTOIRE est un programme structuré qui aide les jeunes étudiants à clarifier leur orientation 
                académique, identifier leurs forces naturelles, construire une stratégie de carrière cohérente et prendre 
                des décisions éclairées.
              </p>
              <p>
                Chaque année, une filière est mise en lumière afin d'aider les étudiants qui y sont d'avoir une clarté 
                sur les nouveaux métiers de la filière, les compétences à avoir, les qualités et les débouchés possibles 
                en fin de cycle.
              </p>
              <div className="modules-list">
                <strong>Cette formation repose sur trois piliers :</strong>
                <ul>
                  <li>Orientation académique</li>
                  <li>Clarté professionnelle</li>
                  <li>Stratégie de carrière</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="axe-item">
            <div className="axe-number">3</div>
            <div className="axe-content">
              <h3>Employabilité et insertion professionnelle (PROPEL)</h3>
              <p>
                PROPEL est un programme qui à pour objectif de permettre aux étudiants qui viennent d'avoir le BTS, 
                La Licence et la Maitrise à avoir un stage de validation afin d'être autoriser à débuter une belle 
                carrière professionnelle.
              </p>
              <div className="modules-list">
                <strong>Nous permettons aux étudiants de :</strong>
                <ul>
                  <li>Entrer dans le monde professionnel ou associatif</li>
                  <li>Avoir les attitudes et aptitudes professionnelles</li>
                  <li>Avoir une productivité & une discipline personnelle</li>
                  <li>Savoir rédiger des documents administratifs</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="founder-message">
          <div className="message-content">
            <div className="quote-icon">"</div>
            <p className="message-text">
              BE TALENTED est née d'une conviction simple mais puissante : Le potentiel africain est immense, 
              mais il nécessite structure, discipline et élévation stratégique.
            </p>
            <p className="message-text">
              Trop de talents restent inexploités. Trop de capacités demeurent sous-développées. 
              Trop de trajectoires manquent de clarté et de direction.
            </p>
            <p className="message-text">
              Nous croyons que le talent seul ne suffit pas. Il doit être cultivé, structuré, renforcé et aligné.
            </p>
            <p className="message-text">
              BE TALENTED se positionne comme un catalyseur d'excellence, une plateforme d'élévation et un 
              accélérateur de performance.
            </p>
            <p className="message-highlight">
              Notre ambition est claire : Contribuer à bâtir une génération africaine compétente, autonome, 
              responsable et mentalement solide. Une génération capable de rivaliser aux standards mondiaux 
              tout en relevant les défis africains.
            </p>
            <p className="message-conclusion">
              Parce que l'avenir de l'Afrique dépend de la qualité de ses talents.
            </p>
            <div className="signature">
              <p className="signature-name">FRÉJUS ZAMBLÉ</p>
              <p className="signature-title">Fondateur BE TALENTED</p>
            </div>
          </div>
        </section>

        <section className="cta-section">
          <h2>Rejoignez-nous</h2>
          <p>
            Vous pouvez nous rejoindre le club des étudiants en visitant notre site officiel ou rejoignez-nous 
            en tant que partenaire pour créer ensemble une nouvelle race d'étudiant hautement performant qui 
            redynamise les entreprises africaines.
          </p>
          <div className="cta-buttons">
            <Link to="/inscription" className="cta-btn primary">Devenir Bénéficiaire</Link>
            <Link to="/inscription" className="cta-btn secondary">Devenir Partenaire</Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Presentation;
